// extracted by mini-css-extract-plugin
module.exports = {"divider":"Sn7dt3OC"};